/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import $ from "jquery";
import Pagination from "rc-pagination/lib/Pagination";
import { useSearchParams } from "react-router-dom";
import MapComponent from "../../Components/PropertiesMap/MapComponent";
import PropertyItem from "../../Components/PropertyItem";
import "./index.css";
import FeatureItem from "../../Components/FeatureItem";
import { PROPERTIES_URL, PROPERTY_TYPE_URL } from "../../Global/API's";
import PropertyDetailQuickView from "../../Components/PropertyDetailQuickView";
import SearchInput from "../../Components/SearchInput/SearchInput";
import LoadingView from "../../Components/Loader";

const BuyProperties = (props) => {
  const [propertiesData, setPropertiesData] = useState({});
  const [propertyTypeData, setPropertyTypeData] = useState(null);
  const [selectedSearchValue] = useState({
    lat: 39.31168,
    lng: -123.21599,
    placeId: "ChIJ29UCh2F4gYARdR2yVhO8-wM",
  });
  const [isLoading, setIsLoading] = useState(true);
  const propertiesMainRef = useRef(null);
  const [contentView, setContentView] = useState("Map");
  const [activeMarker, setActiveMarker] = useState(null);
  const [activeModalId, setActiveModalId] = useState({ id: null, address: "" });
  const [searchParams, setSearchParams] = useSearchParams();

  const pageSize = 20;
  const {
    minPrice,
    maxPrice,
    minBeds,
    maxBeds,
    minBaths,
    maxBaths,
    propertyType,
    minLat,
    maxLat,
    minLon,
    maxLon,
    page,
    search,
  } = Object.fromEntries(
    [
      "minPrice",
      "maxPrice",
      "minBeds",
      "maxBeds",
      "minBaths",
      "maxBaths",
      "propertyType",
      "minLat",
      "maxLat",
      "minLon",
      "maxLon",
      "page",
      "search",
    ].map((key) => [key, searchParams.get(key)])
  );

  const getPropertiesData = async (pageSize, page) => {
    setIsLoading(true);
    try {
      const actualPrice = onCompareValues(minPrice, maxPrice);
      const actualBedrooms = onCompareValues(minBeds, maxBeds);
      const actualBathrooms = onCompareValues(minBaths, maxBaths);

      const rawParams = {
        limit: pageSize,
        page: page,
        minPrice: actualPrice.minVal,
        maxPrice: actualPrice.maxVal,
        minBeds: actualBedrooms.minVal,
        maxBeds: actualBedrooms.maxVal,
        minBaths: actualBathrooms.minVal,
        maxBaths: actualBathrooms.maxVal,
        propertyType,
        minLat,
        maxLat,
        minLon,
        maxLon,
        search,
      };

      const filteredParams = Object.fromEntries(
        Object.entries(rawParams).filter(
          ([, value]) => value !== null && value !== undefined && value !== ""
        )
      );
      setSearchParams(filteredParams);

      const queryString = new URLSearchParams(filteredParams).toString();
      const propertyListUrl = `${PROPERTIES_URL}?${queryString}`;

      const response = await fetch(propertyListUrl, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      const fetchedData = await response.json();
      setPropertiesData(fetchedData);
    } catch (error) {
      console.error("An error occurred:", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const onApplyFilters = () => {
    getPropertiesData(pageSize, 1);
    setTimeout(() => {
      $(
        ".properties-list .sub-header .filter-group .filterDropdown > button"
      ).removeClass("open");
      $(".filter-group").removeClass("open");
    }, 1000);
  };

  const getPropetyTypeData = async () => {
    const response = await fetch(PROPERTY_TYPE_URL);
    const fetchedData = await response.json();
    const filterData = fetchedData.data
      .split(",")
      .filter((item) => item !== "");
    setPropertyTypeData(filterData);
  };

  useEffect(() => {
    const { isActivePropertiesPage } = props;
    isActivePropertiesPage();
    getPropetyTypeData();
    getPropertiesData();
    return () => {
      const { isInActivePropertiesPage } = props;
      isInActivePropertiesPage();
    };
  }, []);

  useEffect(() => {
    onApplyFilters();
  }, [minLat, maxLat, minLon, maxLon]);

  const onToggleMenu = (e) => {
    const eleId = e.target.className.split(" ");
    $("." + eleId[0]).toggleClass("open");
    $("." + eleId[0])
      .parents(".filterDropdown")
      .siblings(".filterDropdown")
      .children(".open")
      .removeClass("open");
  };

  const onCompareValues = (minVal, maxVal) => {
    if (Number(minVal) > Number(maxVal) && minVal !== null && maxVal !== null) {
      return { minVal: maxVal, maxVal: minVal };
    } else {
      return { minVal, maxVal };
    }
  };

  const updatePropertyType = (e) => {
    const { name, value, checked } = e.target;
    const current = propertyType ? propertyType.split(",") : [];

    const updatedValues = checked
      ? [...current, value]
      : current.filter((item) => item !== value);

    setSearchParams((prevParams) => {
      const params = new URLSearchParams(prevParams);
      if (updatedValues.length === 0) {
        params.delete(name);
      } else {
        params.set(name, updatedValues.join(","));
      }
      return params;
    });
  };

  const onHandleView = (e) => {
    setContentView(e.target.value);
  };
  const onHandleFilter = (e) => {
    const { name, value } = e.target;
    setSearchParams((prevParams) => {
      const params = new URLSearchParams(prevParams);
      if (value !== "") {
        params.set(name, value);
      } else {
        params.delete(name);
      }
      return params;
    });
  };

  const renderLoadingView = () => {
    return <LoadingView />;
  };
  const renderPagination = () => {
    return (
      <Pagination
        pageSize={pageSize}
        total={
          propertiesData.status === "Success"
            ? propertiesData.pagination.total
            : 0
        }
        showTitle={false}
        current={page}
        onChange={(current, pageSize) => {
          propertiesMainRef.current.scrollTo({ top: 0, behavior: "smooth" });
          getPropertiesData(pageSize, current);
        }}
      />
    );
  };
  const renderPropertyItemView = () => {
    return (
      <ul className="properties-list-block">
        {propertiesData.data.map((eachProperty) => (
          <PropertyItem
            setActiveModalId={setActiveModalId}
            isRedirect={false}
            handleActiveMarker={handleActiveMarker}
            eachProperty={eachProperty}
            key={eachProperty.property.listingID}
          />
        ))}
      </ul>
    );
  };
  const renderPropertyItemListView = () => {
    return (
      <ul className="properties-list-block">
        {propertiesData.data.map((eachProperty) => (
          <FeatureItem
            eachProperty={eachProperty}
            key={propertiesData.data.listingId}
          />
        ))}
      </ul>
    );
  };
  const renderNoHomesView = () => {
    return (
      <div className="no-listing-block">
        <figure>
          <img src="../assets/images/no-properties-list.png" alt="" />
        </figure>
        <h5>No Properties in this area</h5>
      </div>
    );
  };
  const renderSwitchView = () => {
    if (isLoading) {
      return renderLoadingView();
    } else if (propertiesData.status === "Not Found") {
      return renderNoHomesView();
    } else if (contentView === "Map" || contentView === "Grid") {
      return renderPropertyItemView();
    } else if (contentView === "List") {
      return renderPropertyItemListView();
    }
  };

  const handleActiveMarker = (marker) => {
    if (marker === activeMarker) {
      return;
    }
    setActiveMarker(marker);
  };

  useEffect(() => {
    if (search?.length >= 3 || !search) {
      const timeout = setTimeout(() => {
        onApplyFilters();
      }, 300);
      return () => clearTimeout(timeout);
    }
  }, [search]);

  const onSearch = (e) => {
    const { name, value } = e.target;
    setSearchParams((prevParams) => {
      const params = new URLSearchParams(prevParams);
      if (value !== "") {
        params.set(name, value);
        ["minLat", "maxLat", "minLon", "maxLon"].forEach((name) =>
          params.delete(name)
        );
      } else {
        params.delete(name);
      }
      return params;
    });
  };

  return (
    <>
      <section className="properties-list">
        <div className="sub-header">
          <div className="search-form">
            <div className="input-block">
              <SearchInput value={search || ""} onChange={onSearch} />
            </div>
          </div>
          <button
            type="button"
            className="sub-menu-btn"
            onClick={() => {
              $(".filter-group").addClass("open");
            }}
          >
            Filters <i className="fa fa-angle-down" aria-hidden="true"></i>
          </button>
          <div className="filter-group">
            <button
              className="close-filter-btn"
              onClick={() => {
                $(".filter-group").removeClass("open");
              }}
              type="button"
            >
              <svg
                viewBox="0 0 32 32"
                aria-hidden="true"
                focusable="false"
                role="img"
                className="Icon-c11n-8-100-2__sc-13llmml-0 fBvdWz"
              >
                <path
                  stroke="none"
                  d="M18.83,16,29.41,5.41a2,2,0,0,0-2.82-2.82L16,13.17,5.41,2.59A2,2,0,0,0,2.59,5.41L13.17,16,2.59,26.59a2,2,0,1,0,2.82,2.82L16,18.83,26.59,29.41a2,2,0,0,0,2.82-2.82Z"
                ></path>
              </svg>
            </button>
            <div className="filterDropdown">
              <button
                onClick={onToggleMenu}
                className="priceFilter"
                type="button"
              >
                Price <i className="fa fa-angle-down"></i>
              </button>
              <div className="filterDropdown-menu">
                <div className="form-fileds">
                  <div className="form-group">
                    <div className="form-inputs">
                      <label>$</label>
                      <input
                        type="text"
                        value={minPrice || ""}
                        name="minPrice"
                        onChange={onHandleFilter}
                        className="form-control"
                        placeholder="Min Price"
                      />
                    </div>
                  </div>
                  <span className="separator">-</span>
                  <div className="form-group">
                    <div className="form-inputs">
                      <label>$</label>
                      <input
                        type="text"
                        value={maxPrice || ""}
                        name="maxPrice"
                        onChange={onHandleFilter}
                        className="form-control"
                        placeholder="Max Price"
                      />
                    </div>
                  </div>
                </div>
                <button type="button" onClick={onApplyFilters} className="btn">
                  Apply
                </button>
              </div>
            </div>
            <div className="filterDropdown">
              <button
                onClick={onToggleMenu}
                className="bedsFilter"
                type="button"
              >
                Beds <i className="fa fa-angle-down"></i>
              </button>
              <div className="filterDropdown-menu">
                <div className="form-fileds">
                  <div className="form-group">
                    <div className="form-inputs">
                      <input
                        value={minBeds || ""}
                        name="minBeds"
                        onChange={onHandleFilter}
                        type="text"
                        className="form-control"
                        placeholder="Min Beds"
                      />
                    </div>
                  </div>
                  <span className="separator">-</span>
                  <div className="form-group">
                    <div className="form-inputs">
                      <input
                        value={maxBeds || ""}
                        name="maxBeds"
                        onChange={onHandleFilter}
                        type="text"
                        className="form-control"
                        placeholder="Max Beds"
                      />
                    </div>
                  </div>
                </div>
                <button type="button" onClick={onApplyFilters} className="btn">
                  Apply
                </button>
              </div>
            </div>
            <div className="filterDropdown">
              <button
                onClick={onToggleMenu}
                className="bathsFilter"
                type="button"
              >
                Baths <i className="fa fa-angle-down"></i>
              </button>
              <div className="filterDropdown-menu">
                <div className="form-fileds">
                  <div className="form-group">
                    <div className="form-inputs">
                      <input
                        value={minBaths || ""}
                        name="minBaths"
                        onChange={onHandleFilter}
                        type="text"
                        className="form-control"
                        placeholder="Min Baths"
                      />
                    </div>
                  </div>
                  <span className="separator">-</span>
                  <div className="form-group">
                    <div className="form-inputs">
                      <input
                        value={maxBaths || ""}
                        name="maxBaths"
                        onChange={onHandleFilter}
                        type="text"
                        className="form-control"
                        placeholder="Max Baths"
                      />
                    </div>
                  </div>
                </div>
                <button type="button" onClick={onApplyFilters} className="btn">
                  Apply
                </button>
              </div>
            </div>
            <div className="filterDropdown">
              <button
                onClick={onToggleMenu}
                type="button"
                className="propertyTypeFilter"
              >
                Property Type <i className="fa fa-angle-down"></i>
              </button>
              <div className="filterDropdown-menu multi-dropdown-list">
                {propertyTypeData !== null && (
                  <ul className="multi-dropdown-items">
                    {propertyTypeData.map((eachFilterItem, index) => (
                      <li
                        key={index}
                        className={
                          propertyType?.split(",").includes(eachFilterItem)
                            ? "propertyType-item active"
                            : "propertyType-item"
                        }
                      >
                        <label htmlFor={index} className="type-label">
                          {eachFilterItem}
                        </label>
                        <input
                          name="propertyType"
                          type="checkbox"
                          className="type-input"
                          id={index}
                          value={eachFilterItem}
                          onChange={updatePropertyType}
                          checked={propertyType
                            ?.split(",")
                            .includes(eachFilterItem)}
                        />
                      </li>
                    ))}
                  </ul>
                )}
                <button type="button" onClick={onApplyFilters} className="btn">
                  Apply
                </button>
              </div>
            </div>
          </div>
          <ul className="content-switch-group">
            <li>
              <input
                onChange={onHandleView}
                type="radio"
                value="Map"
                name="content-swith"
                defaultChecked
              />
              <label>
                <i className="fa fa-map" aria-hidden="true"></i>
                Map
              </label>
            </li>
            <li>
              <input
                onChange={onHandleView}
                type="radio"
                value="Grid"
                name="content-swith"
              />
              <label>
                <i className="fa fa-th" aria-hidden="true"></i>
                Grid
              </label>
            </li>
            <li>
              <input
                onChange={onHandleView}
                type="radio"
                value="List"
                name="content-swith"
              />
              <label>
                <i className="fa fa-list-ul" aria-hidden="true"></i>
                List
              </label>
            </li>
          </ul>
        </div>

        <div className="properties-block">
          <div
            onScrollCapture={() => {
              setActiveMarker(null);
            }}
            id="listBlock"
            className={
              (contentView === "Map" && "left-block") ||
              (contentView === "Grid" && "left-block grid-view") ||
              (contentView === "List" && "left-block list-view")
            }
            ref={propertiesMainRef}
          >
            <div className="properties-container">
              <h6 className="no-of-properties">
                Showing{" "}
                {propertiesData.status === "Success"
                  ? propertiesData.pagination.total
                  : 0}{" "}
                Properties
              </h6>
              {renderSwitchView()}
              {propertiesData.pagination?.total > pageSize &&
                !isLoading &&
                renderPagination()}
            </div>
          </div>

          {contentView === "Map" && (
            <div className="map-block">
              <MapComponent
                setActiveModalId={setActiveModalId}
                isRedirect={false}
                handleActiveMarker={handleActiveMarker}
                activeMarker={activeMarker}
                setActiveMarker={setActiveMarker}
                propertiesData={propertiesData ? propertiesData : {}}
                selectedSearchValue={selectedSearchValue}
                setSearchParams={setSearchParams}
              ></MapComponent>
            </div>
          )}
        </div>
      </section>

      <PropertyDetailQuickView
        activeModalId={activeModalId}
        setActiveModalId={setActiveModalId}
      />
    </>
  );
};

export default BuyProperties;
